<template>
  <div class="auth-page">
    <!-- ===== 左侧：品牌卖点宣传 ===== -->
    <section class="auth-hero">
      <div class="ah-brand">
        <span class="ah-logo">🎯</span>
        <span class="ah-name">找客户 · AI客源引擎</span>
      </div>
      <div class="ah-slogan">客源有路，增长有数 <span class="ah-slogan-sep">|</span> 一套系统，搞定找客户全链路</div>

      <h1 class="ah-title">
        你只管<span class="hl">动动嘴</span>，<br>
        AI 自动<span class="hl">找客户</span>
      </h1>
      <p class="ah-sub">一套系统顶上一个部门，节约人力成本，提升引流效率。</p>

      <ul class="ah-feats">
        <li>
          <span class="af-ico">🚀</span>
          <span class="af-txt"><b>爆款复刻引擎</b>把全网爆款，变成你的爆款</span>
        </li>
        <li>
          <span class="af-ico">🤖</span>
          <span class="af-txt"><b>AI 销助</b>像聊天一样下指令，巡房筛人打标私信全自动</span>
        </li>
        <li>
          <span class="af-ico">📡</span>
          <span class="af-txt"><b>全网雷达</b>抖音 / 快手 / 小红书 / 视频号 24 小时自动巡房</span>
        </li>
        <li>
          <span class="af-ico">🎯</span>
          <span class="af-txt"><b>67 大行业精准词库</b>高频行业优先，线索自动打标</span>
        </li>
      </ul>

      <div class="ah-stat">
        <div class="ahs"><b>67</b><span>行业类目</span></div>
        <div class="ahs"><b>4</b><span>内容平台</span></div>
        <div class="ahs"><b>24h</b><span>无人值守</span></div>
      </div>
    </section>

    <!-- ===== 右侧：商户开通三步向导（一个页面搞定） ===== -->
    <section class="auth-form">
      <el-card class="auth-card" shadow="always">
        <!-- 步骤条 -->
        <div class="auth-steps">
          <el-steps :active="step - 1" finish-status="success" simple>
            <el-step title="登录 / 注册" />
            <el-step title="绑定抖音号" />
            <el-step title="选定行业" />
          </el-steps>
        </div>

        <!-- ===== Step 1：登录 / 注册 ===== -->
        <div v-if="step === 1" class="auth-step">
          <div class="auth-head">
            <span class="ah-t">{{ mode === 'login' ? '登录' : '注册商户账号' }}</span>
            <span class="ah-s">{{ mode === 'login' ? '欢迎回来，继续找客户' : '注册即送 20 体验点' }}</span>
          </div>

          <el-form label-position="top">
            <el-radio-group v-if="mode === 'login'" v-model="authType" size="large" style="width:100%; margin-bottom:14px" class="auth-tabs">
              <el-radio-button value="password">🔐 密码登录</el-radio-button>
              <el-radio-button value="code">📱 验证码登录</el-radio-button>
            </el-radio-group>

            <el-form-item label="账号">
              <el-input v-model="phone" placeholder="手机号 / 用户名" maxlength="20" size="large" clearable>
                <template #prefix>📱</template>
              </el-input>
            </el-form-item>

            <el-form-item v-if="mode === 'register' || authType === 'password'" :label="mode === 'register' ? '设置密码' : '密码'">
              <el-input v-model="password" type="password" show-password placeholder="6-20 位密码" maxlength="20" size="large" clearable>
                <template #prefix>🔒</template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="mode === 'register'" label="确认密码">
              <el-input v-model="password2" type="password" show-password placeholder="再次输入密码" maxlength="20" size="large" clearable>
                <template #prefix>🔒</template>
              </el-input>
            </el-form-item>

            <el-form-item v-if="mode === 'login' && authType === 'code'" label="验证码">
              <el-input v-model="code" placeholder="请输入验证码" maxlength="6" size="large" clearable>
                <template #prefix>🔑</template>
                <template #append>
                  <el-button :disabled="countdown > 0 || sending" @click="sendCode">
                    {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="mode === 'register'" label="验证码">
              <el-input v-model="code" placeholder="请输入验证码" maxlength="6" size="large" clearable>
                <template #prefix>🔑</template>
                <template #append>
                  <el-button :disabled="countdown > 0 || sending" @click="sendCode">
                    {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
                  </el-button>
                </template>
              </el-input>
              <div class="hint">📱 内测期短信未开通：验证码固定 <b>123456</b>（点“获取验证码”或直接填写均可）</div>
            </el-form-item>
            <el-form-item v-if="mode === 'register'" label="商户昵称（可选）">
              <el-input v-model="nickname" placeholder="你的店铺 / 品牌名称" maxlength="20" size="large" clearable />
            </el-form-item>
            <el-form-item v-if="mode === 'register'" label="邀请码（可选）">
              <el-input v-model="invite" placeholder="输入邀请码再送 30 推广点" maxlength="10" size="large" clearable>
                <template #prefix>🎁</template>
              </el-input>
            </el-form-item>

            <el-form-item v-if="mode === 'login'" label=" " class="login-extra">
              <div class="login-extra-row">
                <el-checkbox v-model="rememberMe" size="large">记住我</el-checkbox>
                <el-link type="primary" :underline="false" @click="openForgot">忘记密码？</el-link>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="large" style="width:100%" :loading="loading" @click="submit">
                {{ mode === 'login' ? '登 录，直接进入后台' : '注册并进入第 2 步 →' }}
              </el-button>
            </el-form-item>
            <div class="switch-mode">
              <el-link type="primary" @click="mode = mode === 'login' ? 'register' : 'login'">
                {{ mode === 'login' ? '没有账号？注册商户' : '已有账号？去登录' }}
              </el-link>
            </div>

            <!-- ===== 忘记密码弹窗 ===== -->
            <el-dialog v-model="forgotVisible" title="重置密码" width="440px" append-to-body :close-on-click-modal="false">
              <div class="forgot-tip">
                请输入注册手机号获取验证码。<b>内测期验证码固定为 123456</b>。
              </div>
              <el-form label-position="top">
                <el-form-item label="手机号">
                  <el-input v-model="forgotPhone" placeholder="请输入注册手机号" maxlength="11" size="large" clearable>
                    <template #prefix>📱</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="验证码">
                  <div style="display:flex; gap:8px; width:100%">
                    <el-input v-model="forgotCode" placeholder="内测期固定填 123456" maxlength="6" size="large" clearable>
                      <template #prefix>🔑</template>
                    </el-input>
                    <el-button :loading="forgotSending" @click="sendForgotCode">发送验证码</el-button>
                  </div>
                </el-form-item>
                <el-form-item label="新密码">
                  <el-input v-model="forgotPwd" type="password" show-password placeholder="6-20 位新密码" maxlength="20" size="large" clearable>
                    <template #prefix>🔒</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="确认新密码">
                  <el-input v-model="forgotPwd2" type="password" show-password placeholder="再次输入新密码" maxlength="20" size="large" clearable>
                    <template #prefix>🔒</template>
                  </el-input>
                </el-form-item>
              </el-form>
              <template #footer>
                <el-button @click="forgotVisible = false">取消</el-button>
                <el-button type="primary" :loading="forgotSubmitting" @click="submitForgot">重置密码</el-button>
              </template>
            </el-dialog>
          </el-form>
        </div>

        <!-- ===== Step 2：绑定抖音号 ===== -->
        <div v-else-if="step === 2" class="auth-step">
          <div class="auth-head">
            <span class="ah-t">绑定你的抖音号</span>
            <span class="ah-s">平台识别账号身份的唯一凭证，绑定后才能自动发布与巡房</span>
          </div>

          <el-form v-if="!dyAccountId" label-position="top">
            <el-form-item label="抖音昵称">
              <el-input v-model="dyNickname" placeholder="如：即联UV打印机" maxlength="20" size="large" clearable>
                <template #prefix>💬</template>
              </el-input>
            </el-form-item>
            <el-form-item label="抖音号">
              <el-input v-model="dyUsername" placeholder="抖音个人主页的抖音号（不是手机号）" maxlength="30" size="large" clearable>
                <template #prefix>🆔</template>
              </el-input>
            </el-form-item>
          </el-form>
          <el-button v-if="!dyAccountId" type="primary" size="large" style="width:100%" :loading="dyCreating" @click="createAndLogin">
            创建账号并登录抖音 →
          </el-button>

          <div v-else class="dy-done">
            <el-alert type="info" :closable="false" show-icon class="dy-alert">
              <template #title>
                <b>账号已创建</b>：{{ dyNickname || '—' }}（抖音号：{{ dyUsername || '—' }}）
              </template>
            </el-alert>

            <el-tabs v-model="loginTab" stretch>
              <el-tab-pane label="📷 扫码登录" name="qr">
                <div style="text-align:center">
                  <div v-if="qrLoading" style="padding:36px 0;color:#909399">正在生成二维码...</div>
                  <template v-else>
                    <div class="qr-box">
                      <img :src="qrUrl" class="qr-img" @error="qrImgError = true" @load="qrImgError = false" />
                    </div>
                    <div v-if="qrImgError" style="margin-top:-6px;padding-bottom:10px;color:#e6a23c;font-size:12px">二维码加载中…若长时间空白请点「刷新二维码」</div>
                    <div style="margin-top:12px;font-size:13px;color:#606266;line-height:1.7">
                      打开<b>手机抖音 App</b> → 左上角「扫一扫」→ 扫描上方二维码<br>
                      <span style="color:#909399">二维码约 1 分钟有效，超时自动刷新</span>
                    </div>
                    <el-button style="margin-top:10px" size="small" :loading="qrRefreshing" @click="refreshQr">🔄 刷新二维码</el-button>
                  </template>
                </div>
              </el-tab-pane>
              <el-tab-pane label="📲 手机号登录" name="sms">
                <div style="text-align:center;padding:6px 8px">
                  <template v-if="smsState === 'idle' || smsState === 'sms_sending'">
                    <div style="font-size:13px;color:#606266;margin-bottom:16px;line-height:1.7">
                      适用于不方便扫码的场景。验证码将发送至 <b>{{ smsPhone || '下方输入的' }}</b> 手机号短信。
                    </div>
                    <el-input v-model="smsPhone" placeholder="请输入手机号（接收验证码）" maxlength="11" size="large" style="margin-bottom:14px" clearable />
                    <el-button type="primary" size="large" :loading="smsSending" @click="startSmsLogin">发送验证码</el-button>
                    <div style="margin-top:14px;font-size:12px;color:#909399">⚠️ 若发送失败或长时间未收到，可能触发平台风控，建议使用扫码登录</div>
                  </template>
                  <template v-else-if="smsState === 'sms_wait_code'">
                    <div style="font-size:13px;color:#606266;margin-bottom:14px">📩 验证码已发送，请输入收到的短信验证码</div>
                    <el-input v-model="smsCode" placeholder="请输入短信验证码" maxlength="6" size="large" style="margin-bottom:14px" clearable />
                    <el-button type="primary" size="large" :loading="smsSubmitting" @click="submitSmsCode">提交验证码</el-button>
                  </template>
                  <template v-else>
                    <div style="padding:24px 0;color:#606266;font-size:14px">⏳ 验证码已提交，正在登录，请稍候…</div>
                  </template>
                </div>
              </el-tab-pane>
            </el-tabs>

            <el-button style="margin-top:6px;width:100%" size="small" @click="resetDouyin">↩ 换个抖音账号重新绑定</el-button>
          </div>
        </div>

        <!-- ===== Step 3：选定行业 ===== -->
        <div v-else class="auth-step">
          <div class="auth-head">
            <span class="ah-t">选定你的行业</span>
            <span class="ah-s">决定雷达巡房方向与 67 大行业词库的精准匹配</span>
          </div>

          <div class="ind-toolbar">
            <div class="ind-chips">
              <div class="ichip" :class="{ active: indState.group === 'all' }" @click="indState.group = 'all'">全部</div>
              <div
                v-for="g in groups"
                :key="g.id"
                class="ichip"
                :class="{ active: indState.group === g.id }"
                @click="indState.group = g.id"
              >
                {{ g.name }}
                <el-tag v-if="g.b2b" size="small" type="warning" class="ichip-badge">B2B</el-tag>
                <el-tag v-else size="small" type="success" class="ichip-badge">B2C</el-tag>
              </div>
            </div>
            <el-input v-model="indKw" placeholder="搜索行业 / 二级类目" clearable size="small" class="ind-search">
              <template #prefix><span>🔍</span></template>
            </el-input>
          </div>

          <div class="ind-grid">
            <div
              v-for="n in filteredIndNames"
              :key="n"
              class="ind-card"
              :class="{ active: indState.industry === n }"
              @click="onIndustryPick(n)"
            >
              <div class="ic-top">
                <span class="ic-name">{{ n }}</span>
                <el-tag v-if="entryOf(n) && entryOf(n).b2b" size="small" type="warning">B2B</el-tag>
                <el-tag v-else-if="entryOf(n)" size="small" type="success">B2C</el-tag>
              </div>
              <div v-if="entryOf(n) && entryOf(n).sub.length" class="ic-sub">
                <span v-for="s in entryOf(n).sub.slice(0, 3)" :key="s">{{ s }}</span>
                <span v-if="entryOf(n).sub.length > 3">+{{ entryOf(n).sub.length - 3 }}</span>
              </div>
            </div>
            <div v-if="!filteredIndNames.length" class="ind-empty">没有匹配的行业</div>
          </div>

          <div v-if="subList.length" class="ind-sub-pick">
            <div class="ps-t">🧭 「{{ indState.industry }}」细分方向（可多选，用于内容选题定位）</div>
            <div class="ps-list">
              <el-check-tag
                v-for="s in subList"
                :key="s"
                :type="indState.subs.includes(s) ? 'primary' : 'info'"
                :color="indState.subs.includes(s) ? '#2563EB' : ''"
                @change="toggleSub(s)"
              >{{ s }}</el-check-tag>
            </div>
          </div>
        </div>

        <!-- ===== 底部操作 ===== -->
        <div class="auth-foot">
          <el-button v-if="step > 1" @click="prevStep">← 上一步</el-button>
          <span v-else></span>
          <el-button v-if="step === 3" type="primary" size="large" :disabled="!indState.industry" @click="finishGate">
            ✅ 完成开通，进入后台 →
          </el-button>
        </div>
      </el-card>

      <div class="auth-tip">
        <template v-if="step === 1">注册 → 绑定抖音号 → 选定行业，三步完成即成为平台商户，正式打开后台管理界面。</template>
        <template v-else-if="step === 2">第 2 步：绑定抖音号后即可自动发布、评论巡房、线索采集。</template>
        <template v-else>第 3 步：选定行业后，雷达将按该行业的 67 大词库自动巡房打标。</template>
      </div>

      <!-- ===== 底部版权 / 协议 ===== -->
      <div class="auth-copyright">
        <span>© 2026 找客户 · AI客源引擎　闽ICP备XXXXXXXX号</span>
        <div class="ac-links">
          <el-link type="primary" :underline="false" @click="openAgreement('privacy')">隐私协议</el-link>
          <el-link type="primary" :underline="false" @click="openAgreement('terms')">用户协议</el-link>
          <el-link type="primary" :underline="false" @click="openAgreement('about')">关于我们</el-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from '../api'

const STATE_KEY = 'gate_state_v2'

export default {
  name: 'Login',
  data() {
    return {
      step: 1,
      // ---- Step 1 登录 / 注册 ----
      mode: 'login',
      authType: 'password',   // password / code
      phone: '',
      code: '',
      password: '',
      password2: '',
      nickname: '',
      invite: '',
      loading: false,
      countdown: 0,
      sending: false,
      _timer: null,
      // ---- Step 2 绑定抖音号 ----
      dyNickname: '',
      dyUsername: '',
      dyAccountId: 0,
      dyCreating: false,
      loginTab: 'qr',
      qrUrl: '',
      qrLoading: true,
      qrRefreshing: false,
      qrImgError: false,
      pollTimer: null,
      smsState: 'idle',
      smsPhone: '',
      smsCode: '',
      smsSending: false,
      smsSubmitting: false,
      // ---- Step 3 选定行业 ----
      groups: [],
      entries: {},
      indKw: '',
      indState: { group: 'all', industry: '', subs: [] },
      // ---- 登入页增强（专题页改版）----
      rememberMe: localStorage.getItem('auth_remember') === '1',
      // 记住我时回填上次手机号
      _rememberedPhone: localStorage.getItem('auth_phone') || '',
      // 忘记密码弹窗
      forgotVisible: false,
      forgotPhone: '',
      forgotCode: '',
      forgotPwd: '',
      forgotPwd2: '',
      forgotSending: false,
      forgotSubmitting: false
    }
  },
  computed: {
    subList() {
      return (this.entries[this.indState.industry] || {}).sub || []
    },
    filteredIndNames() {
      const g = (this.groups || []).find(x => x.id === this.indState.group)
      let names = g ? g.industries : (this.groups || []).flatMap(x => x.industries)
      const kw = (this.indKw || '').trim().toLowerCase()
      if (kw) {
        names = names.filter(n => {
          const subs = (this.entries[n] || {}).sub || []
          return n.toLowerCase().includes(kw) || subs.some(s => s.toLowerCase().includes(kw))
        })
      }
      return names
    }
  },
  created() {
    // 支持 /login?inv=CODE 自动带邀请码（直接进入注册）
    const p = new URLSearchParams(location.hash.split('?')[1] || location.search)
    const inv = p.get('inv')
    if (inv) {
      this.mode = 'register'
      this.invite = inv
    }
    // 恢复门禁进度（刷新 / 重进页面时接着走，不从头来）
    try {
      const st = JSON.parse(localStorage.getItem(STATE_KEY) || 'null')
      if (st && typeof st === 'object') {
        this.indState = { ...this.indState, ...(st.indState || {}) }
        this.dyNickname = st.dyNickname || ''
        this.dyUsername = st.dyUsername || ''
        const s = Number(st.step) || 1
        if (s >= 1 && s <= 3) this.step = s
      }
    } catch (e) { /* 忽略 */ }
    if (this.step >= 2) this.restoreDouyinAccount()
    if (this.step === 3) this.loadTaxonomy()
    // 【记住我】：回填上次手机号
    if (this.rememberMe && this._rememberedPhone) {
      this.phone = this._rememberedPhone
    }
  },
  beforeUnmount() {
    if (this._timer) clearInterval(this._timer)
    this.stopPoll()
  },
  methods: {
    /* ---------- 门禁状态持久化 ---------- */
    saveState() {
      try {
        localStorage.setItem(STATE_KEY, JSON.stringify({
          step: this.step,
          indState: this.indState,
          dyNickname: this.dyNickname,
          dyUsername: this.dyUsername
        }))
      } catch (e) { /* 忽略 */ }
    },
    prevStep() {
      if (this.step === 3) this.step = 2
      else if (this.step === 2) this.step = 1
      this.saveState()
    },

    /* ---------- 忘记密码（内测期验证码固定 123456）---------- */
    openForgot() {
      this.forgotVisible = true
      this.forgotPhone = this.phone || ''
      this.forgotCode = ''
      this.forgotPwd = ''
      this.forgotPwd2 = ''
    },
    sendForgotCode() {
      if (!/^1\d{10}$/.test(this.forgotPhone)) {
        return this.$message.warning('请输入正确的手机号')
      }
      // 内测期短信未开通：直接提示万能码，不调后端 send-code
      this.forgotSending = true
      setTimeout(() => {
        this.forgotSending = false
        this.$message.success('内测期验证码已生效，请直接填写 123456')
      }, 500)
    },
    async submitForgot() {
      if (!/^1\d{10}$/.test(this.forgotPhone)) {
        return this.$message.warning('请输入正确的手机号')
      }
      if (!this.forgotCode || this.forgotCode !== '123456') {
        return this.$message.warning('内测期验证码固定为 123456')
      }
      if (!this.forgotPwd || this.forgotPwd.length < 6) {
        return this.$message.warning('新密码至少 6 位')
      }
      if (this.forgotPwd !== this.forgotPwd2) {
        return this.$message.warning('两次密码不一致')
      }
      this.forgotSubmitting = true
      try {
        const r = await api.post('/auth/reset-password', {
          phone: this.forgotPhone,
          code: this.forgotCode,
          new_password: this.forgotPwd
        })
        this.$message.success(r.msg || '密码已重置，请用新密码登录')
        this.forgotVisible = false
        this.mode = 'login'
        this.authType = 'password'
        this.phone = this.forgotPhone
        this.password = ''
      } catch (e) {
        this.$message.error(e.message || '重置失败')
      } finally {
        this.forgotSubmitting = false
      }
    },
    openAgreement(type) {
      const map = {
        privacy: { title: '隐私协议', body: '找客户·AI客源引擎隐私协议\n\n本协议说明我们对商户个人信息、账号信息、业务数据的采集、使用、存储与保护范围。内测期所有商户数据仅用于本软件内部使用，不对外共享。\n\n详细条款正式运营后开通。' },
        terms: { title: '用户协议', body: '找客户·AI客源引擎用户协议\n\n1. 商户使用本软件需遵守平台规则与法律法规。\n2. 内测期所有功能、界面、数据可能调整，恕不另行通知。\n3. 严禁通过本软件实施违规营销、诈骗、侵权等行为。\n\n详细条款正式运营后开通。' },
        about: { title: '关于我们', body: '找客户 · AI客源引擎\n\n一套系统，搞定找客户全链路。\n\n爆款复刻引擎、AI 销助、全网雷达、67 大行业精准词库，让内容团队从"手动搬砖"进化为"AI 自动化"。\n\n内测期：欢迎提宝贵意见，让产品更好。' }
      }
      const t = map[type] || map.about
      this.$alert(t.body, t.title, { confirmButtonText: '我知道了', customStyle: { maxWidth: '560px' } })
    },

    /* ---------- Step 1：登录 / 注册 ---------- */
    async sendCode() {
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      this.sending = true
      try {
        const r = await api.post('/auth/send-code', { phone: this.phone })
        this.$message.success(r.msg || '验证码已发送')
        this.countdown = 60
        this._timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) clearInterval(this._timer)
        }, 1000)
      } catch (e) {
        this.$message.error(e.message || '发送失败')
      } finally {
        this.sending = false
      }
    },
    async submit() {
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      if (this.mode === 'login') {
        if (this.authType === 'password') {
          if (!this.password) return this.$message.warning('请输入密码')
        } else {
          if (!this.code) return this.$message.warning('请输入验证码')
        }
      } else {
        if (!this.password) return this.$message.warning('请设置密码（6-20 位）')
        if (this.password.length < 6) return this.$message.warning('密码至少 6 位')
        if (this.password !== this.password2) return this.$message.warning('两次输入的密码不一致')
        if (!this.code) return this.$message.warning('请输入验证码')
      }
      this.loading = true
      try {
        const url = this.mode === 'login' ? '/auth/login' : '/auth/register'
        const body = { phone: this.phone, nickname: this.nickname }
        if (this.mode === 'login') {
          if (this.authType === 'password') body.password = this.password
          else body.code = this.code
        } else {
          body.code = this.code
          body.password = this.password
          if (this.invite) body.invite = this.invite
        }
        const r = await api.post(url, body)
        const u = r.user
        localStorage.setItem('current_user', JSON.stringify(u))
        localStorage.setItem('user_id', String(u.id))
        localStorage.setItem('user_phone', u.phone)
        if (u.token) localStorage.setItem('api_token', u.token)
        // 【记住我】：勾选后记住手机号，下次自动回填
        if (this.mode === 'login') {
          if (this.rememberMe) {
            localStorage.setItem('auth_phone', this.phone)
            localStorage.setItem('auth_remember', '1')
          } else {
            localStorage.removeItem('auth_phone')
            localStorage.removeItem('auth_remember')
          }
        }
        if (this.mode === 'login') {
          // 老用户：直接进后台，不重复走开通流程
          localStorage.removeItem(STATE_KEY)
          // 【批次16 修复】老用户登录必须清掉注册流程标记 need_onboard，否则 main.js 路由守卫会把这个跳转拦回 /login（表现为「登录成功但进不了后台」）
          localStorage.removeItem('need_onboard')
          this.$message.success('登录成功，欢迎回来 👋')
          this.$router.push('/dashboard')
        } else {
          // 新用户：进入第 2 步绑定抖音号（同一页面）
          localStorage.setItem('need_onboard', '1')
          this.step = 2
          this.saveState()
          this.$message.success('注册成功，送你 20 体验点 🎉 下一步绑定抖音号')
        }
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      } finally {
        this.loading = false
      }
    },

    /* ---------- Step 2：绑定抖音号 ---------- */
    async createAndLogin() {
      if (!this.dyNickname.trim()) return this.$message.warning('请输入抖音昵称')
      if (!this.dyUsername.trim()) return this.$message.warning('请输入抖音号')
      this.dyCreating = true
      try {
        const acc = await api.post('/accounts/', {
          platform: 'douyin',
          username: this.dyUsername.trim(),
          nickname: this.dyNickname.trim(),
          industry: ''
        })
        this.dyAccountId = acc.id
        this.saveState()
        // 启动扫码登录流程
        await api.post(`/accounts/${acc.id}/login`)
        this.qrUrl = ''
        this.qrLoading = true
        this.qrImgError = false
        this.loadQr()
        if (this.pollTimer) clearInterval(this.pollTimer)
        this.pollTimer = setInterval(() => this.pollStatus(), 3000)
        this.$message.success('账号已创建，请用抖音 App 扫码登录')
      } catch (e) {
        this.$message.error('创建账号失败: ' + (e.message || ''))
      } finally {
        this.dyCreating = false
      }
    },
    loadQr() {
      if (!this.dyAccountId) return
      this.qrUrl = `/api/v1/accounts/${this.dyAccountId}/login-qr?v=${Date.now()}`
      this.qrLoading = false
    },
    refreshQr() {
      this.qrRefreshing = true
      this.loadQr()
      setTimeout(() => { this.qrRefreshing = false }, 1000)
    },
    stopPoll() {
      if (this.pollTimer) { clearInterval(this.pollTimer); this.pollTimer = null }
    },
    async pollStatus() {
      if (!this.dyAccountId) return
      try {
        const st = await api.get(`/accounts/${this.dyAccountId}/login-status`)
        if (st.status === 'success') {
          this.stopPoll()
          this.goStep3()
          this.$message.success('🎉 抖音号绑定成功！下一步选择你的行业')
        } else if (st.status === 'failed') {
          this.stopPoll()
          this.$message.error('登录失败: ' + (st.detail || '请重新扫码'))
        } else if (st.status === 'waiting_scan') {
          // 二维码已过期更新 → 前端跟随刷新
          this.loadQr()
        } else if (st.status === 'sms_wait_code') {
          this.smsState = 'sms_wait_code'
        } else if (st.status === 'sms_submitted') {
          this.smsState = 'sms_submitted'
        } else if (st.status === 'sms_sending') {
          this.smsState = 'sms_sending'
        }
      } catch (e) { /* 网络抖动，等下一轮 */ }
    },
    async startSmsLogin() {
      if (!/^1\d{10}$/.test(this.smsPhone)) {
        this.$message.warning('请输入正确的 11 位手机号')
        return
      }
      this.smsSending = true
      try {
        const r = await api.post(`/accounts/${this.dyAccountId}/sms-login`, { phone: this.smsPhone })
        if (r && r.started === false) {
          this.$message.warning((r && r.message) || '已有登录流程进行中')
          return
        }
        this.$message.success('验证码发送请求已提交，请留意手机短信')
      } catch (e) {
        this.$message.error('发送验证码失败: ' + (e.message || ''))
      } finally {
        this.smsSending = false
      }
    },
    async submitSmsCode() {
      if (!this.smsCode || this.smsCode.length < 4) {
        this.$message.warning('请输入收到的短信验证码')
        return
      }
      this.smsSubmitting = true
      try {
        const r = await api.post(`/accounts/${this.dyAccountId}/sms-code`, { code: this.smsCode })
        if (r && r.ok) {
          this.smsState = 'sms_submitted'
          this.$message.success('验证码已提交，正在登录…')
        } else {
          this.$message.warning((r && r.message) || '提交失败，请重试')
        }
      } catch (e) {
        this.$message.error('提交验证码失败: ' + (e.message || ''))
      } finally {
        this.smsSubmitting = false
      }
    },
    resetDouyin() {
      this.stopPoll()
      this.dyAccountId = 0
      this.qrUrl = ''
      this.qrLoading = true
      this.dyNickname = ''
      this.dyUsername = ''
      this.smsState = 'idle'
      this.smsPhone = ''
      this.smsCode = ''
      this.saveState()
    },
    async restoreDouyinAccount() {
      // 刷新 / 重进后恢复：已有抖音账号则直接接上登录流程
      try {
        const accs = await api.get('/accounts/', { params: { platform: 'douyin' } })
        const list = Array.isArray(accs) ? accs : (accs.accounts || [])
        if (!list.length) return
        const me = list.find(x => !x.is_logged_in) || list[0]
        this.dyAccountId = me.id
        this.dyNickname = me.nickname || this.dyNickname || ''
        this.dyUsername = me.username || this.dyUsername || ''
        this.saveState()
        if (me.is_logged_in) {
          this.goStep3()
        } else {
          await api.post(`/accounts/${me.id}/login`)
          this.qrUrl = ''
          this.qrLoading = true
          this.qrImgError = false
          this.loadQr()
          if (this.pollTimer) clearInterval(this.pollTimer)
          this.pollTimer = setInterval(() => this.pollStatus(), 3000)
        }
      } catch (e) { /* 忽略 */ }
    },
    goStep3() {
      this.stopPoll()
      this.step = 3
      this.saveState()
      if (!this.groups.length) this.loadTaxonomy()
    },

    /* ---------- Step 3：选定行业 ---------- */
    async loadTaxonomy() {
      try {
        const r = await api.get('/industries/taxonomy')
        this.groups = r.groups || []
        this.entries = r.entries || {}
      } catch (e) {
        console.error('行业分类加载失败:', e)
      }
    },
    entryOf(name) { return this.entries[name] || null },
    toggleSub(s) {
      const i = this.indState.subs.indexOf(s)
      if (i >= 0) this.indState.subs.splice(i, 1)
      else this.indState.subs.push(s)
      this.saveState()
    },
    onIndustryPick(n) {
      this.indState.industry = n
      // 行业变更时清空不属于该行业的已选二级类目
      if (!this.indState.subs.every(s => this.subList.includes(s))) this.indState.subs = []
      // 同步到已绑定的抖音账号
      if (this.dyAccountId) {
        api.put(`/industries/accounts/${this.dyAccountId}/industry`, { industry: n }).catch(() => {})
      }
      this.saveState()
    },
    finishGate() {
      if (!this.indState.industry) return this.$message.warning('请先选择一个行业')
      localStorage.removeItem('need_onboard')
      localStorage.removeItem(STATE_KEY)
      this.$message.success('商户开通完成！欢迎使用找客户 · AI客源引擎 🎉')
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style scoped>
/* ===== 登入专题页：左卖点 + 右三步向导（全屏无菜单） ===== */
.auth-page {
  display: flex;
  min-height: 100vh;
  background: radial-gradient(1200px 700px at 10% -10%, rgba(37, 99, 235, .30), transparent 60%),
              radial-gradient(900px 600px at 110% 110%, rgba(16, 185, 129, .18), transparent 55%),
              #0b1120;
}

/* 左侧卖点 */
.auth-hero {
  flex: 1 1 44%;
  max-width: 600px;
  padding: 48px 52px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #e2e8f0;
  position: relative;
  overflow: hidden;
}
.ah-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
}
.ah-logo {
  font-size: 26px;
  filter: drop-shadow(0 0 10px rgba(56, 189, 248, .6));
}
.ah-slogan {
  font-size: 13px;
  color: #38bdf8;
  margin: 4px 0 28px 0;
}
.ah-title {
  font-size: 42px;
  font-weight: 900;
  line-height: 1.3;
  color: #f1f5f9;
  margin-bottom: 16px;
  letter-spacing: 1px;
}
.ah-title .hl {
  background: linear-gradient(90deg, #38bdf8, #22c55e);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.ah-sub {
  font-size: 17px;
  color: #cbd5e1;
  line-height: 1.7;
  margin-bottom: 30px;
}
.ah-feats {
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
}
.ah-feats li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 11px 14px;
  margin-bottom: 10px;
  background: rgba(148, 163, 184, .08);
  border: 1px solid rgba(148, 163, 184, .16);
  border-radius: 12px;
  font-size: 15px;
  line-height: 1.5;
  color: #cbd5e1;
}
.af-ico {
  font-size: 22px;
  flex-shrink: 0;
  line-height: 1.2;
}
.af-txt b {
  color: #fff;
  margin-right: 6px;
}
.ah-stat {
  display: flex;
  gap: 26px;
  padding-top: 20px;
  border-top: 1px solid rgba(148, 163, 184, .16);
}
.ahs {
  display: flex;
  flex-direction: column;
}
.ahs b {
  font-size: 28px;
  font-weight: 900;
  color: #fff;
}
.ahs span {
  font-size: 12px;
  color: #94a3b8;
}

/* 右侧向导 */
.auth-form {
  flex: 1 1 56%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 24px;
  background: #0a0f1a;
}
.auth-card {
  width: 640px;
  max-width: 100%;
  border-radius: 14px;
}
.auth-card :deep(.el-card__body) {
  padding: 18px 20px 16px;
}

/* 步骤条 */
.auth-steps {
  margin-bottom: 16px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ebeef5;
}

.auth-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-bottom: 14px;
}
.ah-t {
  font-size: 20px;
  font-weight: 800;
  color: #1f2937;
}
.ah-s {
  font-size: 13px;
  color: #6b7280;
}
.auth-tabs {
  display: flex;
}
.auth-tabs :deep(.el-radio-button__inner) {
  width: 100%;
}
.hint {
  font-size: 13px;
  color: #e6a23c;
  margin-top: 6px;
}
.switch-mode {
  text-align: center;
  padding-top: 2px;
}

/* Step 2 已创建提示 */
.dy-done { margin-top: 2px; }
.dy-alert { margin-bottom: 12px; }
.dy-alert b { font-weight: 700; }

/* 二维码 */
.qr-box {
  display: inline-block;
  padding: 10px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.qr-img { display: block; width: 208px; height: 208px; object-fit: contain; }

/* ===== 行业选择（浅色适配白底卡片） ===== */
.ind-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 14px;
}
.ind-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1 100%;
}
.ichip {
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 999px;
  border: 1px solid #dcdfe6;
  background: #f5f7fa;
  color: #475569;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all .15s;
}
.ichip:hover { border-color: #2563EB; color: #2563EB; }
.ichip.active { background: #2563EB; border-color: #2563EB; color: #fff; }
.ichip .ichip-badge { padding: 0 6px; }
.ind-search { width: 230px; max-width: 100%; }

.ind-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(158px, 1fr));
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
  padding: 2px;
}
.ind-card {
  padding: 11px 13px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  cursor: pointer;
  transition: all .15s;
}
.ind-card:hover { border-color: #2563EB; background: #eff6ff; }
.ind-card.active {
  border-color: #2563EB;
  background: #eff6ff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, .3);
}
.ic-top { display: flex; align-items: center; justify-content: space-between; gap: 6px; }
.ic-name { font-size: 14px; font-weight: 600; color: #1e293b; }
.ic-sub { margin-top: 7px; display: flex; flex-wrap: wrap; gap: 5px; }
.ic-sub span {
  font-size: 12px;
  padding: 2px 7px;
  border-radius: 6px;
  background: #e2e8f0;
  color: #64748b;
}
.ind-empty { padding: 26px; text-align: center; color: #94a3b8; font-size: 14px; grid-column: 1/-1; }

.ind-sub-pick {
  margin-top: 14px;
  padding: 13px 15px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
}
.ps-t { font-size: 14px; color: #334155; margin-bottom: 10px; }
.ps-list { display: flex; flex-wrap: wrap; gap: 8px; }

/* 底部操作 */
.auth-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #ebeef5;
}
.auth-foot .el-button { flex-shrink: 0; }

.auth-tip {
  margin-top: 18px;
  max-width: 640px;
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.7;
  text-align: center;
}

/* ===== 底部版权 ===== */
.auth-copyright {
  margin-top: 14px;
  max-width: 640px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.7;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.auth-copyright > span { color: #64748b; }
.ac-links { display: flex; gap: 18px; justify-content: center; }
.ac-links .el-link { font-size: 12px; color: #94a3b8; }
.ac-links .el-link:hover { color: #38bdf8; }

/* ===== 记住我 + 忘记密码 ===== */
.login-extra { margin-bottom: 4px; }
.login-extra :deep(.el-form-item__label) { height: 32px; line-height: 32px; padding: 0; }
.login-extra-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* ===== 忘记密码弹窗 ===== */
.forgot-tip {
  padding: 10px 14px;
  margin-bottom: 14px;
  background: linear-gradient(135deg, rgba(56, 189, 248, .1), rgba(34, 197, 94, .06));
  border-left: 3px solid #38bdf8;
  border-radius: 6px;
  font-size: 13px;
  color: #334155;
  line-height: 1.6;
}
.forgot-tip b { color: #2563eb; }

/* ===== 主按钮：科技黑蓝渐变 ===== */
.auth-card :deep(.el-button--primary) {
  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 60%, #38bdf8 100%);
  border: none;
  box-shadow: 0 4px 14px rgba(37, 99, 235, .35);
  transition: all .25s;
}
.auth-card :deep(.el-button--primary:hover),
.auth-card :deep(.el-button--primary:focus) {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 60%, #60a5fa 100%);
  box-shadow: 0 6px 18px rgba(37, 99, 235, .5);
  transform: translateY(-1px);
}
.auth-card :deep(.el-button--primary.is-loading) {
  background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 60%, #38bdf8 100%);
}

/* Slogan 分隔符 */
.ah-slogan-sep {
  color: rgba(56, 189, 248, .4);
  margin: 0 8px;
  font-weight: 400;
}

/* 表单字号 */
.auth-card :deep(.el-form-item__label) { font-size: 15px; }
.auth-card :deep(.el-input__inner) { font-size: 16px; }
.auth-card :deep(.el-input__inner::placeholder) { font-size: 15px; }
.auth-card :deep(.el-radio-button__inner) { font-size: 15px; }

/* ===== 手机端 ===== */
@media (max-width: 767px) {
  .auth-page { flex-direction: column; }
  .auth-hero { display: none; }
  .auth-form {
    flex: 1 1 100%;
    padding: 24px 16px;
    background: linear-gradient(135deg, #0b1120 0%, #0a0f1a 100%);
  }
  .auth-card { width: 100%; }
  .auth-tip { max-width: 100%; }
  .ind-grid { grid-template-columns: repeat(auto-fill, minmax(138px, 1fr)); max-height: 300px; }
  .ind-search { width: 100%; flex: 1 1 100%; }
  .auth-foot { flex-direction: column-reverse; }
  .auth-foot .el-button { width: 100%; }
  .qr-img { width: 180px; height: 180px; }
}
</style>
